export default "__VITE_ASSET__decd9755__"